import kinetikApi from './kinetikAPI';

export default {
  getAccessToken: () =>
    kinetikApi
      .post('/proxy/lyft-access-token', undefined, {
        serviceName: 'proxy',
      })
      .then((res) => res.data),
  getTripEstimatation: (params) =>
    kinetikApi
      .get('/proxy/lyft/v1/cost', {
        ...params,
        serviceName: 'proxy',
      })
      .then((res) => res.data),
  getRideTypes: (params) =>
    kinetikApi
      .get('/proxy/lyft/v1/ridetypes', {
        ...params,
        serviceName: 'proxy',
      })
      .then((res) => res.data),
  getDriverAvailability: (params) =>
    kinetikApi
      .get('/proxy/lyft/v1/concierge-driver-availability', {
        ...params,
        serviceName: 'proxy',
      })
      .then((res) => res.data),
};
